export default {
  FETCH_ACTIVE_SUBSCRIPTIONS: '@YOLA_TEMPLATE_GALLERY/SUBSCRIPTIONS/FETCH_ACTIVE_SUBSCRIPTIONS',
  SET_ACTIVE_SUBSCRIPTIONS: '@YOLA_TEMPLATE_GALLERY/SUBSCRIPTIONS/SET_ACTIVE',
  SET_CURRENT_PACKAGE: '@YOLA_TEMPLATE_GALLERY/SUBSCRIPTIONS/SET_CURRENT_PACKAGE',
};
